import React from "react";
import "./ProductPricing.css";
import { Helmet } from "react-helmet-async";
const ProductPricing = () => {
  return (
    <>
    <Helmet>
        <title>Product Pricing | Nifty10</title>
        <meta
          name="description"
          content="Explore Nifty10's product pricing details for entry fees, rewards, and premium features."
        />
      </Helmet>
    <section className="product-pricing-section terms-conditions">
      <h2 className="terms-header">Product Pricing</h2>
      <p className="privacy-text">
        At Nifty10, the core of our gaming experience lies in users selecting the
        market trend for the day before they can start playing games on our app.
        We are dedicated to providing a superior play creation experience where
        users are empowered with ample knowledge and challenges to leverage their
        skills to the fullest.
      </p>

      <p className="privacy-text">
        Once a user selects the market trend, they can participate by joining
        one of our available pricing pools, which range from ₹1 to ₹129. This
        flexible pricing structure ensures that users can engage with our games
        at a level that suits their preferences, budget, and experience.
      </p>

      <p className="privacy-text">
        Whether you're a casual player exploring the basics or a seasoned
        enthusiast ready to take on high-stakes games, we have a pricing tier
        tailored just for you. Each pricing tier corresponds to a specific prize pool,
        increasing your chances of earning higher rewards as you move up.
      </p>

      <p className="privacy-text">
        For players who are just starting out, we offer low-entry games that are
        both educational and entertaining. As your confidence grows, you can
        participate in premium contests with larger prize money and more competition.
      </p>

      <p className="privacy-text">
        Nifty10 also provides special free entry games and promotional events
        that allow users to participate without spending any money while still
        competing for real rewards.
      </p>

      <p className="privacy-text">
        Our goal is to keep the gameplay fair, transparent, and accessible to
        everyone—regardless of how much you're willing to spend. With no hidden
        charges and instant entry confirmations, your gaming journey is smooth
        and secure from the start.
      </p>
  <p className='privacy-sub-list-item'>Examples Slots</p>
<div className="pricing-table">
  <div className="pricing-card">
    <h3>₹19 Pool</h3>
    <ul>
      <li>🏆 First Prize: <span className="bold">₹564</span></li>
      <li>💰 Pool Prize: <span className="bold">₹2964</span></li>
      <li>🌀 Flexible</li> {/* placeholder for now */}
    </ul>
  </div>

  <div className="pricing-card">
    <h3>₹29 Pool</h3>
    <ul>
      <li>🏆 First Prize: <span className="bold">₹860</span></li>
      <li>💰 Pool Prize: <span className="bold">₹4524</span></li>
      <li>✅ Guaranteed</li> {/* placeholder for now */}
    </ul>
  </div>

  <div className="pricing-card">
    <h3>₹39 Pool</h3>
    <ul>
      <li>🏆 First Prize: <span className="bold">₹1156</span></li>
      <li>💰 Pool Prize: <span className="bold">₹6024</span></li>
      <li>🌀 Flexible</li> {/* placeholder for now */}
    </ul>
  </div>

  <div className="pricing-card">
    <h3>₹49 Pool</h3>
    <ul>
      <li>🎯 Prize Pool: <span className="bold">₹7644</span></li>
      <li>🏆 First Prize: <span className="bold">₹1453</span></li>
      <li>✅ Guaranteed</li> {/* placeholder for now */}
    </ul>
  </div>
</div>



    </section></>
  );
};

export default ProductPricing;
